import { compose } from 'recompose';
import { connect } from 'react-redux';

import {
  getIsCommissionShop,
  activeShopPaymentDepositsEnabled,
  canUseGiftCards,
  getActiveType,
  hasBarberBankAccount, isBrandViewActive,
} from '../../../../auth/selectors';
import {
  getProductSalesSum,
  getServiceSalesSum,
  getTotalSum,
} from '../../selectors';
import withNewDesignStyles from '../../../../common/hoc/withNewDesignStyles';
import Dashboard from '../components/Dashboard';
import {
  getCancellationsAmount,
  getCancellationsCount,
  getGiftCardSalesGrossTotal,
  getGiftCardSalesTotalCollected,
  getItemsProductChart,
  getItemsProductQuantity,
  getItemsProductTotal,
  getItemsServiceChart,
  getItemsServiceQuantity,
  getItemsServiceTotal,
  getLastDepositAmount,
  getLastDepositDate,
  getNextDepositAmount,
  getNoShowsAmount,
  getNoShowsCount,
  getSalesFees,
  getSalesGrossDiscounts,
  getSalesGrossRefunds,
  getSalesGrossTotal,
  getSalesLoanRepayment,
  getSalesNetTotal,
  getSalesTaxes,
  getSalesTips,
  getSalesTotalCash,
  getSalesTotalCollected,
  getSalesTotalGiftCard,
  getSalesTotalPos,
  getSalesTotalSquire,
  getUnchargedCount,
  getGrossSecuredDepositsAmount,
  getGrossSecuredDepositsCount,
  getUnchargedAmount,
  getSalesTaxBreakdown,
  getBreakdownNewMembershipCount,
  getBreakdownRecurringMembershipCount,
  getBreakdownTotal,
  getBreakdownNewMembershipTotal,
  getBreakdownRecurringMembershipTotal,
  getBreakdownProductTotal,
  getBreakdownServiceTotal,
} from '../../metrics/selectors';
import withGrossSalesKind from '../../hoc/withGrossSalesKind';

const DashboardContainer = compose(
  withNewDesignStyles,
  connect(
    state => ({
      shop: state.auth.shop,
      upcomingDeposits: getNextDepositAmount(state),
      grossSales: getSalesGrossTotal(state),
      servicesCount: getItemsServiceQuantity(state),
      productsCount: getItemsProductQuantity(state),
      paymentPosCard: getSalesTotalPos(state),
      paymentSquireCard: getSalesTotalSquire(state),
      paymentCash: getSalesTotalCash(state),
      paymentGiftCards: getSalesTotalGiftCard(state),
      servicesTotal: getItemsServiceTotal(state),
      servicesChartData: getItemsServiceChart(state),
      productsTotal: getItemsProductTotal(state),
      productsChartData: getItemsProductChart(state),
      servicesRevenue: getServiceSalesSum(state),
      productRevenue: getProductSalesSum(state),
      totalRevenue: getTotalSum(state),
      showGiftCards: canUseGiftCards(state) || isBrandViewActive(state),
      refunds: getSalesGrossRefunds(state),
      discounts: getSalesGrossDiscounts(state),
      fees: getSalesFees(state),
      netSales: getSalesNetTotal(state),
      taxes: getSalesTaxes(state),
      tips: getSalesTips(state),
      totalCollected: getSalesTotalCollected(state),
      canceledAppointmentsCount: getCancellationsCount(state),
      canceledAppointmentsAmount: getCancellationsAmount(state),
      noShowAppointmentsCount: getNoShowsCount(state),
      noShowAppointmentsAmount: getNoShowsAmount(state),
      grossSecuredDepositsCount: getGrossSecuredDepositsCount(state),
      grossSecuredDepositsAmount: getGrossSecuredDepositsAmount(state),
      unchargedAppointmentsCount: getUnchargedCount(state),
      unchargedAppointmentsAmount: getUnchargedAmount(state),
      loanRepayment: getSalesLoanRepayment(state),
      giftCardsTotalCollected: getGiftCardSalesTotalCollected(state),
      giftCardsSoldGross: getGiftCardSalesGrossTotal(state),
      lastDepositDate: getLastDepositDate(state),
      lastDepositAmount: getLastDepositAmount(state),
      showDepositsSection: getActiveType(state) === 'shop'
        || (getActiveType(state) === 'barber' && hasBarberBankAccount(state)),
      showGiftCardSection: !(getActiveType(state) === 'barber' && getIsCommissionShop(state)),
      taxBreakdown: getSalesTaxBreakdown(state),
      newMembershipCount: getBreakdownNewMembershipCount(state),
      recurringMembershipCount: getBreakdownRecurringMembershipCount(state),
      grossTotal: getBreakdownTotal(state),
      newMembershipGrossTotal: getBreakdownNewMembershipTotal(state),
      recurringMembershipGrossTotal: getBreakdownRecurringMembershipTotal(state),
      productGrossTotal: getBreakdownProductTotal(state),
      serviceGrossTotal: getBreakdownServiceTotal(state),
      paymentDepositsEnabled: activeShopPaymentDepositsEnabled(state),
    }),
  ),
  withGrossSalesKind,
)(Dashboard);

export default DashboardContainer;
